import { defineComponent } from "vue";
import IconButton from "../common/base/IconButton.vue.mjs";
import SettingIcon from "../common/icons/SettingIcon.vue.mjs";
import { useBasicStore } from "../../stores/basic.mjs";
import { storeToRefs } from "pinia";
import { useI18n } from "../../locales/index.mjs";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "SettingControl",
  setup(__props) {
    const { t } = useI18n();
    const basicStore = useBasicStore();
    const { showSettingDialog } = storeToRefs(basicStore);
    function handleShowSettingDialog() {
      basicStore.setShowSettingDialog(!basicStore.showSettingDialog);
    }
    return { __sfc: true, t, basicStore, showSettingDialog, handleShowSettingDialog, IconButton, SettingIcon };
  }
});
export {
  _sfc_main as default
};
